var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTimeHeaderBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 139,
    viewBox: "0 0 133 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.849 78.008C122.814 117.614 97.0184 145.722 57.8555 137.596C18.6927 129.471 -6.54344 90.7628 1.49122 51.1563C9.52588 11.5498 46.2175 -6.20361 85.3803 1.93438C124.555 10.0601 138.884 38.4014 130.849 78.008Z",
    fill: "#0A7E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTimeHeaderBlob);
export default __webpack_public_path__ + "static/media/wait-time-header-blob.9b399cd444e5b8ce6763769fedfc5fc0.svg";
export { ForwardRef as ReactComponent };